export function logActionRequired(message: string) {
  if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
}

export function logActionRequiredIf(message: string, conditional: boolean) {
  if (conditional) {
    logActionRequired(message);
  }
}
